const home = {
  "hero.badge": "AI That Talks Like You",
  "hero.title.line1": "Your AI Assistant,",
  "hero.title.line2": "Always Online on WhatsApp",
  "hero.subtitle": "Smart replies, bulk messaging, and deep insights — one platform that handles every conversation like a pro.",
  "hero.cta.getStarted": "Get Started Free",
  "hero.cta.viewPlans": "View Plans",
  "hero.stat.messages": "Messages",
  "hero.stat.responseRate": "Response Rate",
  "hero.chat.senderName": "Sarah Johnson",
  "hero.chat.online": "online",
  "hero.chat.placeholder": "Type a message...",
  "hero.chat.msg1": "Hey! Can your AI handle bulk WhatsApp messaging?",
  "hero.chat.msg2": "Absolutely! We support unlimited bulk messaging with smart scheduling.",
  "hero.chat.msg3": "That's perfect! Let me set it up right away.",
  "hero.scrollLabel": "Scroll to advantages",
  "advantages.heading.badge": "Why Choose Us",
  "advantages.heading.title": "Advantages That Set Us Apart",
  "advantages.heading.subtitle": "Every detail is crafted to deliver exceptional value. Discover what makes our service the preferred choice.",
  "testimonials.badge": "Social Proof",
  "testimonials.title.line1": "Loved by Teams",
  "testimonials.title.line2": "Around the World",
  "cta.title": "Ready to Take Control?",
  "cta.subtitle": "Start managing your advantages today. It is free to get started, and you can upgrade anytime as you grow.",
  "cta.viewPlans": "View Plans",
  "cta.talkToSales": "Talk to Sales",
  "advantages.item.0.title": "24/7 Expert Support",
  "advantages.item.0.description": "Our dedicated team is available around the clock to resolve any issues and ensure your business never misses a beat.",
  "advantages.item.0.category": "Service",
  "advantages.item.1.title": "Transparent Pricing",
  "advantages.item.1.description": "No hidden fees, no surprise charges. Know exactly what you pay for with our clear and straightforward pricing structure.",
  "advantages.item.1.category": "Pricing",
  "advantages.item.2.title": "Premium Quality",
  "advantages.item.2.description": "Every service is delivered with meticulous attention to detail and adherence to the highest industry standards.",
  "advantages.item.2.category": "Quality",
  "advantages.item.3.title": "Fast Turnaround",
  "advantages.item.3.description": "Time is money. Our optimized processes deliver results 40% faster than industry averages without compromising quality.",
  "advantages.item.3.category": "Service",
  "advantages.item.4.title": "Custom Solutions",
  "advantages.item.4.description": "We do not believe in one-size-fits-all. Every solution is tailored to your specific business needs and goals.",
  "advantages.item.4.category": "Service",
  "advantages.item.5.title": "Data Security",
  "advantages.item.5.description": "Enterprise-grade encryption and compliance with SOC 2, GDPR, and ISO 27001 standards to keep your data safe.",
  "advantages.item.5.category": "Quality",
  "advantages.item.6.title": "Scalable Plans",
  "advantages.item.6.description": "Start small and grow seamlessly. Our infrastructure scales with your business at every stage of growth.",
  "advantages.item.6.category": "Pricing",
  "advantages.item.7.title": "Satisfaction Guarantee",
  "advantages.item.7.description": "Not happy? We will make it right. Our 100% satisfaction guarantee ensures you get the value you deserve.",
  "advantages.item.7.category": "Service",
  "advantages.item.8.title": "Industry Certified",
  "advantages.item.8.description": "Our team holds over 50 industry certifications and stays current with the latest trends and technologies.",
  "advantages.item.8.category": "Quality",
  "testimonials.item.0.name": "Sarah Mitchell",
  "testimonials.item.0.role": "CEO at Horizon Tech",
  "testimonials.item.0.quote": "Switching to this service was the best decision we made. The 24/7 support alone has saved us countless hours of downtime.",
  "testimonials.item.1.name": "James Rodriguez",
  "testimonials.item.1.role": "Operations Director at ScaleUp Inc",
  "testimonials.item.1.quote": "The transparent pricing and custom solutions fit our exact needs. We finally have a partner who understands our business.",
  "testimonials.item.1.avatar": "JR",
  "testimonials.item.1.avatarColor": "bg-accent-100 text-accent-700",
  "testimonials.item.2.name": "Emily Chen",
  "testimonials.item.2.role": "Founder at BrightWave",
  "testimonials.item.2.quote": "Their fast turnaround is no joke. We have cut our project delivery time by 35% since partnering with them.",
  "testimonials.item.2.avatar": "EC",
  "testimonials.item.2.avatarColor": "bg-secondary-100 text-secondary-700",
  "testimonials.item.3.name": "Michael Torres",
  "testimonials.item.3.role": "CTO at DataFlow Systems",
  "testimonials.item.3.quote": "Data security was our top concern. Their enterprise-grade compliance gave us the confidence to move our entire infrastructure.",
  "testimonials.item.3.avatar": "MT",
  "testimonials.item.3.avatarColor": "bg-primary-100 text-primary-700",
  "testimonials.item.4.name": "Lisa Park",
  "testimonials.item.4.role": "VP Marketing at GrowthLab",
  "testimonials.item.4.quote": "The satisfaction guarantee is not just marketing speak. They genuinely went above and beyond when we needed adjustments.",
  "testimonials.item.4.avatar": "LP",
  "testimonials.item.4.avatarColor": "bg-accent-100 text-accent-700",
  "testimonials.item.5.name": "David Kim",
  "testimonials.item.5.role": "Head of Product at Nexus",
  "testimonials.item.5.quote": "Scalable plans meant we could start with what we needed and grow as our user base expanded. Seamless transition.",
  "testimonials.item.5.avatar": "DK",
  "testimonials.item.5.avatarColor": "bg-secondary-100 text-secondary-700",

  // Industries / Categories
  "industries.badge": "Tailored Industry Solutions",
  "industries.title": "Designed for Growth Across Every Sector",
  "industries.subtitle": "Whether you run an online store, clinic, or real estate firm, Wyzon delivers the exact automation you need to accelerate sales and customer satisfaction.",
  "industries.ecommerce.title": "E-Commerce & Retail",
  "industries.ecommerce.desc": "Recover abandoned carts, automate order confirmations and tracking, and boost conversions by up to 35%.",
  "industries.clinics.title": "Clinics & Healthcare",
  "industries.clinics.desc": "Book appointments, automate patient reminders, and answer pricing and consultation questions 24/7.",
  "industries.realestate.title": "Real Estate & Developers",
  "industries.realestate.desc": "Qualify leads automatically, send brochures and floor plans over WhatsApp, and schedule site visits instantly.",
  "industries.services.title": "Agencies & B2B Services",
  "industries.services.desc": "Automated technical support, seamless B2B inquiry routing, and sub-second average response times.",

  // FAQs for AEO & GEO
  "faq.badge": "Frequently Asked Questions",
  "faq.title.line1": "Everything You Need to Know",
  "faq.title.line2": "About the Wyzon Platform",
  "faq.subtitle": "Direct answers to the most common questions about automation, AI, and connecting WhatsApp & Messenger.",
  "faq.item.0.q": "What is Wyzon and how does it help my business?",
  "faq.item.0.a": "Wyzon is an all-in-one conversational AI platform that unifies WhatsApp and Facebook Messenger chats into a single inbox, featuring smart voice & text replies, CRM pipeline, and anti-ban bulk campaigns that boost response rates up to 98%.",
  "faq.item.1.q": "How does the unified omnichannel chat work?",
  "faq.item.1.a": "Wyzon lets you manage both WhatsApp and Facebook Messenger from a single synchronized dashboard using official Meta Graph APIs and real-time Webhooks.",
  "faq.item.2.q": "Does Wyzon transcribe and understand customer voice notes?",
  "faq.item.2.a": "Yes! Wyzon transcribes incoming Arabic and English voice notes with high precision using Gemini AI, allowing the bot to understand customer intent and reply with natural voice or text.",
  "faq.item.3.q": "How does Wyzon protect my accounts from bans during bulk campaigns?",
  "faq.item.3.a": "We use intelligent spacing intervals, dynamic message variations, and anti-spam throttles that strictly comply with messaging policies.",
  "faq.item.4.q": "Do I need coding experience to use Wyzon?",
  "faq.item.4.a": "Not at all. The platform is 100% No-Code. You can connect your channels in minutes and train the AI with a simple CSV or settings interface.",
  "faq.item.5.q": "Is there a free trial available?",
  "faq.item.5.a": "Yes, you can get started for free, connect your accounts, and test all automation features before upgrading to any paid plan.",
};

export default home;